import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SiteRoots } from 'common-models';
import { Configuration } from '../../Configuration';

export const rootApiSlice = createApi({
  reducerPath: 'rootApi',
  tagTypes: ['root'],
  baseQuery: fetchBaseQuery({
    baseUrl: Configuration.ApiUrl,
  }),
  endpoints: (builder) => ({
    getRoots: builder.query<SiteRoots, void>({
      query: () => '/',
      providesTags: [{ type: 'root', id: 'root' }],
    }),
  }),
});

export const { useGetRootsQuery } = rootApiSlice;
